<template>
  <div class="tag page">
    <UiDataBox :loading="loading" :isEmpty="isTagNotFound" :error="errorTag">
      <div class="head BOLD">#{{ item.name }} </div>
    </UiDataBox>

    <UiDataBox v-if="item.id" :loading="loading" :isEmpty="isEmptyAlbums" :error="errorAlbumsList">
      <AlbumList :items="albums"></AlbumList>

      <Pagination
        :total="pagination.total"
        :limit="pagination.limit"
        :page.sync="pagination.page">
      </Pagination>

    </UiDataBox>
  </div>
</template>

<script>
  import * as tagsService from '../services/tags.service'

  import AlbumList from '../pages/gallery/AlbumList.vue'
  import Pagination from '../components/Pagination.vue'
  import setModelMixin from '../mixins/setModelMixin'
  import prepareFetchParamsMixin from '../mixins/prepareFetchParamsMixin'
  import setPageTitle from '../mixins/setPageTitle'

  export default {
    name: 'Tag',
    props: {
      limit: {
        type: Number,
        'default': 20
      },
      page: {
        type: Number,
        'default': 0
      }
    },
    components: {
      AlbumList,
      Pagination
    },
    mixins: [setModelMixin, prepareFetchParamsMixin, setPageTitle],
    data () {
      return {
        loading: false,
        errorTag: false,
        errorAlbumsList: false,
        item: {
          id: '',
          name: ''
        },
        albums: [],
        pagination: {
          total: 0,
          page: this.page,
          limit: this.limit
        }
      }
    },

    methods: {
      fetchTag () {
        this.loading = true
        tagsService.getByName(this.$route.params.name)
          .then(response => {
            this.item = this.setModelMixin(this.item, response.data)
            this.setPageTitle(this.item.name)
          }).then(() => this.fetchAlbumsByTagId())
          .catch(error => {
            this.errorTag = error.message
            console.log(error)
          }).finally(() => { this.loading = false })
      },
      fetchAlbumsByTagId () {
        this.loading = true
        tagsService.getAlbumsByTagId(this.item.id, this.getFetchParams)
          .then(response => {
            this.albums = response.data.content
            this.pagination.total = response.data.total
          }).catch(error => {
            this.errorAlbumsList = error.message
            console.log(error)
          }).finally(() => { this.loading = false })
      }
    },

    computed: {
      getFetchParams () {
        let pagination = this.prepareFetchParamsMixin({
          page: this.pagination.page,
          limit: this.pagination.limit
        })

        return { ...pagination }
      },
      isTagNotFound () {
        return !Object.keys(this.item).length
      },
      isEmptyAlbums () {
        return !this.albums.length
      }
    },

    mounted () {
      this.fetchTag()
    }
  }
</script>

<style lang="scss" scoped>
  .tag.page {
    padding-top: 30px;
    font-family: $font-title;
    .head {
      font-size: 60px;
      text-transform: uppercase;
      padding-bottom: 20px;
      padding-left: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Tag.vue